import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, forkJoin } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Payment } from '../../models/payment.model';



@Injectable({ providedIn: 'root' })
export class PaymentService {
  private api = environment.api;
  private apiMyServy = environment.apimyservy;

  constructor(private http: HttpClient) {}

  public PayOrdersById(paymentOrdersId: string, data: any): Observable<any> {
    let urlbase = `${environment.api}/api/v1/mobile-payment/pay-orders-by-mobile-payment/${paymentOrdersId}`;
    return this.http.post<any>(urlbase, data);
  }

  public EvenLog(data: any): Observable<any> {
    const urlbase = `${this.apiMyServy}/api/EventLogger`;

    // Map old keys to the new EventLogger requirements
    const structuredPayload = {
      entityName: data?.entityName || 'PaymentOrder',
      entityId: data?.entityId || data?.metadata?.paymentOrderId || data?.metadata?.paymentOrdersId || localStorage.getItem('orderId') || '00000000-0000-0000-0000-000000000000',
      action: data?.action || (data?.message?.includes?.('exitosamente') ? 'PAYMENT_SUCCESS' : 'PAYMENT_FAILED'),
      performedBy: data?.performedBy || data?.createdBy || localStorage.getItem('email') || localStorage.getItem('userId') || 'Anonymous',
      metadata: data?.metadata || data
    };

    console.log('[PaymentService] Sending structured payload to EventLogger:', structuredPayload);
    return this.http.post<any>(urlbase, structuredPayload).pipe(
      map((response) => {
        console.log('[PaymentService] Eventlog endpoint response:', response);
        return response;
      })
    );
  }

  /**
   * Get banks from Console API provider endpoints (/api/v1/payment-banca-amiga/banks, etc.)
   */
  public GetConsoleBanks(workspaceId: string): Observable<any> {
    const providerId = workspaceId || '';

    // Define correct public endpoints (relative in dev for proxying, absolute in production)
    const baseUrl = environment.production ? this.apiMyServy : '';
    const endpoints = [
      `${baseUrl}/api/v1/payment-banca-amiga/banks`,
      `${baseUrl}/api/v1/payment-banco-activo/banks`,
      `${baseUrl}/api/v1/payment-banco-plaza/banks`,
    ];
    console.log('[PaymentService] Fetching banks from Console API endpoints using x-provider-id:', providerId);
    
    // Set the required x-provider-id header
    const headers = new HttpHeaders().set('x-provider-id', providerId);

    // Make the requests sending the header
    const requests = endpoints.map((url) =>
      this.http.get<any>(url, { headers }).pipe(
        catchError((err) => {
          console.warn('[PaymentService] Failed to fetch banks from:', url, err);
          return of(null);
        })
      )
    );

    return forkJoin(requests).pipe(
      map((results: any[]) => {
        let allBanks: any[] = [];
        results.forEach((res) => {
          if (res) {
            const list = res?.banks || res?.data || res?.result || (Array.isArray(res) ? res : []);
            if (Array.isArray(list)) {
              allBanks = allBanks.concat(list);
            }
          }
        });
        return { banks: allBanks };
      })
    );
  }


  public getPaymentMethodConfig(workspaceId: string): Observable<any>{
    const providerId = workspaceId;

    if(!providerId){
      return new Observable((observer) => {
        observer.error(new Error('providerId is required'));
      });
    }
    const base = environment.production ? this.apiMyServy : '';
    const url = `${base}/api/v1/PaymentMethodConfiguration/provider/${providerId}`;

    console.log('[PaymentService] Fetching PaymentMethodConfiguration for provider:', { url, providerId });
    return this.http.get<any>(url).pipe(
      map((res) => {
        console.log('[PaymentService] Fetched PaymentMethodConfiguration data:', res);
        return res;
      })
    );
  }

  /**
   * Charge a credit card via Stripe using the Console API.
   * Endpoint: POST /api/v1/PaymentStripe/charge
   */
  public chargeStripeCard(payload: any, workSpaceId: string): Observable<any> {
    const providerId = workSpaceId;
    const base = environment.production ? this.apiMyServy : '';
    const url = `${base}/api/v1/PaymentStripe/charge`;
    const headers = new HttpHeaders().set('x-provider-id', providerId);
    console.log('[PaymentService] POST chargeStripeCard:', { url, payload, providerId });
    return this.http.post<any>(url, payload, {headers});
  }
}
